import { useEffect, RefObject } from 'react';

const useResizeObserverHeight = (
  ref: RefObject<Element | null>,
  onHeightChange?: (height: number) => void,
) => {
  useEffect(() => {
    if (!onHeightChange || !ref.current) return;
    let isFirst = true;
    const observer = new ResizeObserver((entries) => {
      if (isFirst) {
        isFirst = false;
        return;
      }
      for (const entry of entries) {
        const height = Math.round(
          entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height,
        );
        onHeightChange(height);
      }
    });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [onHeightChange]);
};

export default useResizeObserverHeight;
